import { render } from "./HeroiconsOutlineBookmarkAlt.vue?vue&type=template&id=461b9f5a"
const script = {}

import exportComponent from "/home/fran/Desarrollo/soyasi/ebim-crm/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineBookmarkAlt.vue"]])

export default __exports__